var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tooltip',{attrs:{"text":_vm.text,"allowHTML":true}},[_c('span',{staticClass:"label label-warning",on:{"hover":function($event){$event.preventDefault();}}},[_c('i',{staticClass:"fa fa-exclamation-triangle",attrs:{"aria-hidden":"true"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }